export enum ComponentModeEnum {
  ADD = 'ADD',
  EDIT = 'EDIT',
  VIEW = 'VIEW',
}
